import { effect, inject, Injectable } from '@angular/core';
import { MonetizationStatus } from '@api';
import { MonetizationResourceService } from '../resources/monetization-resource.service';
import { CustomizationService } from './customization.service';

/**
 * Sets the monetization-dependent customization defaults (price column, price
 * in the overview, payment status column) from the account's monetization
 * status. Kept out of CustomizationService, which also holds the colour scheme
 * and so runs on public pages; this one is started by the signed-in shell.
 */
@Injectable({ providedIn: 'root' })
export class CustomizationMonetizationSyncService {
  private customization = inject(CustomizationService);
  private monetizationResource = inject(MonetizationResourceService);

  constructor() {
    effect(async () => {
      const monetizationStatus = await this.monetizationResource.monetizationStatus.load();
      const isEnrolled = monetizationStatus?.monetizationStatus === MonetizationStatus.Enrolled;

      this.customization.updateCustomizationKey('showPriceColumnInWebinarList', isEnrolled, {
        shouldOverrideIfConfiguredByUser: true,
        shouldShowHint: true,
        requiredHintValue: true,
      });

      this.customization.updateCustomizationKey(
        'showPaymentStatusColumnInParticipantList',
        isEnrolled,
        {
          shouldOverrideIfConfiguredByUser: true,
          shouldShowHint: false,
          requiredHintValue: false,
        },
      );

      this.customization.updateCustomizationKey('showPriceInWebinarOverview', isEnrolled, {
        shouldOverrideIfConfiguredByUser: true,
        shouldShowHint: false,
        requiredHintValue: true,
      });
    });
  }
}
